import request from "@/config/serve.js";
// 查询
export function listApi(params) {
  return request("post", "/cpsAppInfo/list", {
    deleted: false,
    ...params,
  });
}

/**
 * 修改配置
 * @param {*} params
 * @returns
 */
export function configApi(name, params) {
  return request("post", `/cpsAppInfo/${name}`, params);
}
// 查询
export function getApkList(data) {
  return request("post", "/app/appInfoList", data);
}

export function getDownloadSource(params = {}) {
  return request("post", "/apiGo/api/v1/cpsreport/dropDownList", params);
}
